module.exports = __webpack_public_path__ + "img/1.b44aea24.png";